var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 52",
    style: {
      fill: "none",
      opacity: 0.509
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "m60.256 21.385-2.094 1.658h-9.58l7.981-6.321a.716.716 0 0 1 1 .116l2.807 3.543a.716.716 0 0 1-.114 1.004z",
    transform: "translate(-43.434 -14.793)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M31.813 70.11h-1l.756-.6.009.008a.8.8 0 0 1 .234.565zm1.6 5.535v1.916a.24.24 0 0 1-.24.24h-3.356a1.2 1.2 0 0 1 0-2.395h3.353a.239.239 0 0 1 .24.239zm-2.989.958a.6.6 0 1 0-.6.6.6.6 0 0 0 .597-.603zm-.6 1.6h3.14v2.874a1.2 1.2 0 0 1-1.2 1.2H18.1a1.2 1.2 0 0 1-1.2-1.2V70.482a1.2 1.2 0 0 1 1.2-1.2h.79l-.354.825h-.41a.4.4 0 0 0-.4.4v.027a.4.4 0 0 0 .4.4h13.633a1.2 1.2 0 0 1 1.2 1.2v2.874h-3.14a1.6 1.6 0 0 0 0 3.193z",
    transform: "translate(-14.898 -62.271)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M44.323 1.839 40.169.058a.716.716 0 0 0-.938.375l-3.3 7.688h.453l7.666-5.944.363-.288a.672.672 0 0 0-.09-.05z",
    transform: "translate(-32.045 .13)",
    style: {
      fill: "#939393"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.48d3626a4be8a81b45c706a04785a056.svg";
export { ForwardRef as ReactComponent };